import { createRouter, createWebHistory } from 'vue-router';

const Home = () => import('../views/Home.vue');
const Corp = () => import('../views/Corp.vue');
const TechRecruit = () => import('../views/TechRecruit.vue');

// import TechRecruit from '@/views/TechRecruit.vue'
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/recruit',
    name: 'TechRecruit',
    component: TechRecruit
  },
  {
    path: '/corp',
    name: 'Corp',
    component: Corp
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;



// import Vue from 'vue'
// import VueRouter from 'vue-router'
// const Home=()=>import('../views/Home')
// const Corp=()=>import('../views/Corp')

// Vue.use(VueRouter)

//   const routes = [
//   {
//     path: '/',
//     name: 'Home',
//     component: Home
//   },
//   {
//     path: '/corp',
//     name: 'Corp',
//     component: Corp
//   }
// ]

// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })

// export default router
